"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCORDIONS = void 0;
const ACCORDIONS = exports.ACCORDIONS = 'accordions';
//# sourceMappingURL=constants.js.map